import Vuex, {mapActions} from 'vuex'
import ProfileRequestService from 'js/services/api/passenger/profile-requests.js'
import template from './index.pug'
import qrcode from 'qrcode-generator'

export default {
  name: 'profile-request-view-form-modal',
  template: template(),

  props: {
    profileRequestId: {
      type: String,
      required: true
    },
    // posible values (view, create and edit)
    typeForm: {
      type: String,
      default: 'create'
    }
  },

  data() {
    const vm = this

    return {
      fileValidations: {
        formats: [
          'image/png',
          'image/jpg',
          'image/jpeg',
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ],
        maxSize: 2*1024*1024
      },
      maxDocuments: 1,
      showModalForm: false,
      profile_id: '',
      requestedProfileName: '',
      valid_until: '',
      formErrors: {
        other_documents: []
      },
      account: vm.account,
      media_profiles: [],
      documents_needed: [],
      documents_needed_file: [
        { key: 'other_documents', files: [] }
      ],
      profileRequest: [],
      date_needed: false,
      selected_profile: false,
      datepickerConfig: {
        allowInput: true,
        formatDate(date) {
          return moment(date).format('DD/MM/YYYY')
        },
        parseDate(date) {
          return moment(date, 'DD/MM/YYYY').toDate()
        },
        disableMobile: true,
        minDate: moment().toDate()
      },
      qrPath: null,
    }
  },

  computed: {
    profileRequestProfileIdSelectOptions() {
      return this.$administrativeArea.media_profiles.map(media_profile => ({
        label: `${media_profile.name}`, value: media_profile.id
      }))
    },

    problemFields() {
      return this.profileRequest?.objections?.fields_with_problems || {}
    },

    /**
     * Gets an array of the files needed which can be re-used in validations
     * @returns Array
     */
    files_needed() {
      if (_.isEmpty(this.problemFields)) return []

      let files_to_check = []
      for (const [index, value] of Object.entries(this.problemFields.files)) {
        if (value === 1) files_to_check.push(index)
      }

      return files_to_check
    },

    OtherDocumentsFile() {
      if (!Array.isArray(this.profileRequest.files)) return []

      const array = this.profileRequest.files.filter(file => file.file_type === 'other_documents')

      return (array || [])
        // Ordenar por el campo "position_documents" antes de mapear
        .sort((a, b) => (a.position_documents || 0) - (b.position_documents || 0))
        .map(file => ({...file, other_index: file.position_documents + 1}))
    },

    disableSendButton() {
      switch (this.typeForm) {
        case 'edit': return !this.validateBeforeUpdate()
        default: break
      }
    },

    showSendButton() {
      return ['edit', 'create'].includes(this.typeForm)
    },
    orderedDocumentsNeeded() {
      if (this.profileRequest) {
        // const docs = [...this.profileRequest.files]

        return this.profileRequest.files.sort((a, b) => {
          if (a.key === 'other_documents') return 1
          if (b.key === 'other_documents') return -1

          return 0
        })
      }

      return []
    },
    visibleOtherDocuments() {
      let documents = []
      const destination = this.documents_needed_file.find(
        doc => doc.key === 'other_documents'
      )

      const files = destination?.files || []

      // total number of visible inputs = uploaded files + 1 empty (max. maxDocuments)
      const total = Math.min(files.length + 1, this.maxDocuments)

      // we return a sequentially numbered list
      documents = Array.from({ length: total }, (_, i) => ({
        pos: i, // índice real en el array
        label: i + 1, // número de documento visible
        file: files[i] || null,
        uid: files[i]?.name || `empty-${i}`
      }))

      return documents
    }
  },

  created() {
    this.documents_needed = []
    this.loadProfileRequest()
  },
  watch: {
    profile_id(newVal) {
      let doc_needed = []
      this.documents_needed = []
      this.documents_needed_file = []

      const selected_profile = this.$administrativeArea.media_profiles.find(mp => {
        return mp.id === newVal
      })

      this.requestedProfileName = selected_profile.name
      this.date_needed = selected_profile.requires_expiration_date

      // Validate presence document
      if (selected_profile.documents) {
        Object.keys(selected_profile.documents).forEach(key => {
          if (selected_profile.documents[key] === true) {
            doc_needed.push(key)
          }
        })
      }
      doc_needed = this.isMinor(doc_needed)
      this.documents_needed = doc_needed
      this.maxDocuments = selected_profile.maximum_other_documents
    }
  },
  methods: {
    ...mapActions(['closeViewProfileAccreditationRequest']),

    closeModalForm() {
      this.$router.push({
        ...this.$route,
        query: {
          showModalForm: undefined
        }
      })
    },
    submit() {
      // this.resetErrors()
      if (this.typeForm === 'create' && this.valid()) {
        this.createOrUpdateProfileRequest()
      } else if (this.typeForm === 'edit' && this.validateBeforeUpdate()) {
        this.createOrUpdateProfileRequest('update')
      } else {
        // no action
      }
    },
    valid() {
      const vm = this
      let is_valid = true
      if (vm.profile_id === '') {
        vm.formErrors.profile_id = vm.$t('paymentMedias.profileRequests.formErrors.required')
        is_valid = false
      }

      if (vm.selected_profile) {
        if (vm.selected_profile.requires_expiration_date) {
          if (vm.valid_from === '') {
            vm.formErrors.valid_from = vm.$t('paymentMedias.profileRequests.formErrors.required')
            is_valid = false
          }

          if (vm.valid_until === '') {
            vm.formErrors.valid_until = vm.$t('paymentMedias.profileRequests.formErrors.required')
            is_valid = false
          }
        }

        if (vm.documents_needed) {
          Object.values(vm.documents_needed).forEach(identifier => {
            if (vm.documents_needed_file[identifier] === undefined) {
              vm.formErrors[identifier] = vm.$t('paymentMedias.profileRequests.formErrors.required')
              is_valid = false
            }
          })
        }
      }

      return is_valid
    },

    /**
     * This method performs the pre-validation of the form before sending
     * @returns {Boolean}
     */
    validateBeforeUpdate() {
      const vm = this
      let is_valid = true
      const today = moment.utc()
      const objectKeys = Object.keys(this.problemFields)

      objectKeys.forEach(key => {
        switch(key) {
          // Dates
          // case 'valid_from': // Removed, not needed
          case 'valid_until':
            // If the key is not required we break out of the test
            if(!this.problemFields[key] || this.problemFields[key] === 0) break
            
            if(!this[key]) return false

            const newVal = moment.utc(this[key])
            const request_until = moment.utc(this.profileRequest.valid_from)

            if(!newVal.isValid()) return false
            if(newVal.isBefore(today)) return false
            if(newVal.isSame(request_until, 'day')) return false
            break
          case 'files':
            if(!_.isEmpty(vm.files_needed)) {
              this.files_needed.forEach(k => {               
                if(!this.documents_needed_file[k]) is_valid = false
              })
            }
            return false
        }
      })
      return is_valid
    },
    resetErrors() {
      this.formErrors = {}
      this.acceptConditionsError = ''
    },
    onFileChange(event, identifier, id) {
      this.$set(this.formErrors, identifier, '')
      const errorMessages = []
      const selectedFile = event.target.files[0]

      if (!selectedFile) {
        switch (this.typeForm){
          case 'edit':
            this.$set(this.formErrors, identifier, $t('paymentMedias.errors.required'))
            break
          default: break
        }
        return
      }

      if(!this.fileValidations.formats.includes(selectedFile.type)) errorMessages.push(this.$t('paymentMedias.profileRequests.formErrors.invalidType'))
      if(this.fileValidations.maxSize < selectedFile.size) errorMessages.push(this.$t('paymentMedias.profileRequests.formErrors.tooBig'))

      if (!_.isEmpty(errorMessages)) {
        this.$set(this.formErrors, identifier, errorMessages.join(' | '))
      } else {
        this.$set(this.documents_needed_file, id, [selectedFile])
      }
    },
    createOrUpdateProfileRequest(action = 'create') {
      const vm = this
      let cont = 0
      const file_types = []
      const formData = new FormData()
      formData.append('profile_id', this.profile_id)
      formData.append('valid_from', this.valid_from)
      formData.append('valid_until', this.valid_until)
      formData.append('administrative_area_id', vm.$currentAccount.administrative_area_id)
      formData.append('rut', vm.$currentAccount.rut)
      formData.append('document_type', vm.$currentAccount.document_type || 1)

      if (this.documents_needed_file !== undefined) {
        // eslint-disable-next-line no-restricted-syntax
        for (const identifier in this.documents_needed_file) {
          if (this.documents_needed_file[identifier] !== undefined) {
            const file = this.documents_needed_file[identifier]
            const file_old = this.profileRequest.files.filter(f => f.file === identifier)
            if (!file) return
            if (!file_types.includes(file_old[0].file_type)) {
              file_types.push(file_old[0].file_type)
            }
            if (file_old[0].file_type === 'other_documents') {
              formData.append(`${file_old[0].file_type}[${identifier}]`, file[0])
            } else {
              formData.append(`${file_old[0].file_type}[${identifier}]`, file[0])
            }
          }
        }
      }
      file_types.forEach(type => {
        formData.append('file_types[]', type)
      })

      if (action === 'create') {
        ProfileRequestService.create(formData).then(() => {
          this.sendNotificationSuccess()
          this.close()
        }, response => {
          if (response.status === 422) {
            this.sendNotificationFormErrors()
            this.formErrors = response.body.errors
          } else {
            this.sendNotificationFailure()
          }
        })
      } else {
        ProfileRequestService.update(this.profileRequestId, formData).then(() => {
          this.sendNotificationSuccess()
          this.close()
          /** Una vez actualizado, el valor de ViewProfileAccreditationRequest
           * se deja en false para volver a la vista inicial
           */
          this.closeViewProfileAccreditationRequest()
        }, response => {
          if (response.status === 422) {
            this.sendNotificationFormErrors()
            this.formErrors = response.body.errors
          } else {
            this.sendNotificationFailure()
          }
        })
      }
    },

    close() {
      this.$emit('close')
    },
    sendNotificationSuccess() {
      this.$notifications.send({
        id: 'profile-request-success',
        text: this.$t('paymentMedias.profileRequests.successMessage'),
        type: 'success',
        close: true
      })
    },
    sendNotificationFormErrors() {
      this.$notifications.send({
        id: 'profile-request-form-errors',
        text: this.$t('paymentMedias.profileRequests.formErrorsMessage'),
        type: 'error',
        close: true
      })
    },
    sendNotificationFailure() {
      this.$notifications.send({
        id: 'profile-request-failure',
        text: this.$t('paymentMedias.profileRequests.failureMessage'),
        type: 'error',
        close: true
      })
    },
    // Get profile request with id
    async loadProfileRequest(){
      await ProfileRequestService.show(this.profileRequestId, {}).then(response => {
        this.profileRequest = response
        if(this.profileRequest.locator != null){
          this.generateQR(this.profileRequest.locator)
        }
      })
      this.completeForm()
    },
    // Load form with data of current profile request selected
    completeForm() {
      this.profile_id = this.profileRequest.profile_id
      this.valid_until = moment.utc(this.profileRequest.valid_until).toDate();

      this.files_needed.forEach(file => this.$set(this.formErrors, file, this.$t('paymentMedias.errors.documents')))
    },
    // Sets the title based on the behavior of the form
    setTitle() {
      let title;
      switch (this.typeForm) {
        case 'create':
          title = this.$t('paymentMedias.profileRequests.requestAcreditedProfile')
          break
        case 'view':
          title = this.$t('paymentMedias.profileRequests.viewRequest')
          break
        case 'edit':
          title = this.$t('paymentMedias.profileRequests.editRequest')
          break
      }
      return title;
    },
    // Allows you to download a document
    downloadFile(fileType) {
      const document = this.profileRequest.files.find(item => item.file_type === fileType)
      ProfileRequestService.downloadFile(this.profileRequest.id, document.file)
    },

    // Allows you to download a document
    downloadOtherDocumentsFile(file) {
      ProfileRequestService.downloadFile(this.profileRequest.id, file.file)
    },
    // Checks if the file exists to add a link
    fileExist(fileType) {
      const document = this.profileRequest.files.find(item => item.file_type === fileType)
      if (document === undefined) {
        return false
      }

      return true
    },
    fileCharge(fileType) {
      return this.profileRequest.files.find(item => item.file_type === fileType)
    },
    isMinor(doc_needed) {
      const birthday = this.$currentAccount.Birthday

      if (!birthday) {
        throw new Error("Formato de fecha inválido")
      }

      const birthDate = moment(birthday).toDate()

      const today = new Date()
      let age = today.getFullYear() - birthDate.getFullYear()
      const monthDiff = today.getMonth() - birthDate.getMonth()
      const dayDiff = today.getDate() - birthDate.getDate()

      // Si aún no cumplió años este año, restamos 1
      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--
      }

      if (age < 18) {
        doc_needed = doc_needed.filter(
          doc => doc !== 'other_documents'
        )
      } else {
        doc_needed = doc_needed.filter(
          doc => doc !== 'parent_dni'
        )
      }

      return doc_needed
    },
    generateQR(string) {
      const qr = qrcode(0, 'L')
      qr.addData(string)
      qr.make()
      const value = qr.getModuleCount()
      this.qrPath = qr.createImgTag(value, value, 'QR Code')
    },  
  }
}
